import React, { useEffect } from "react";
import { Outlet, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as loginActions from "../redux/actions/loginActions";
import Sidebar from "../library/sidebar/sidebar";
import Navbar from "../library/navbar/navbar";
import "../library/sidebar/sidebar.scss";
import { Drawer } from "@mui/material";

import {
  ADDCASE,
  ADMIN_CONTRACTOR_DETAILS,
  LANDING_PAGE,
  SW_INSPECTION_ADD,
  PAGE_NOT_FOUND,
  ADD_INSPECTION_NEW,
  TOOL_BOX_USER,
} from "../constant/routeContant";

// Removed useAuthTokenRefresh import

const PrivateRoutes = (props) => {
  const { window } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // 🔥 Removed proactive token refresh on route change to avoid logout on hard refresh
  // useAuthTokenRefresh(location);

  const isAuth = useSelector((state) => state.login.userSuccess);
  const token = localStorage.getItem("id_token");

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const drawerWidth = 320;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const islanding = location?.pathname === LANDING_PAGE;
  const isPageNotFound = location?.pathname === PAGE_NOT_FOUND;

  const handleRoute = (url) => {
    if (ADMIN_CONTRACTOR_DETAILS === url) {
      const USERID = JSON.parse(localStorage.getItem("userInfo"));
      navigate(ADMIN_CONTRACTOR_DETAILS, {
        state: {
          rowsss: {
            id: USERID.contractorId,
            contractorName: USERID.contractorName,
            grade: USERID.contractorGrade,
          },
          editMode: false,
        },
      });
    } else if (SW_INSPECTION_ADD === url) {
      navigate(SW_INSPECTION_ADD, {
        state: {
          addDirectInspection: true,
          editMode: false,
        },
      });
    } else if (ADDCASE === url) {
      navigate(ADDCASE, {
        state: {
          addCase: true,
          editMode: false,
        },
      });
    } else if (ADD_INSPECTION_NEW === url) {
      navigate(ADD_INSPECTION_NEW, {
        state: {
          addInspection: true,
          editMode: false,
        },
      });
    } else if (TOOL_BOX_USER === url) {
      navigate(TOOL_BOX_USER, {
        state: {
          safetyMeetingUser: true,
        },
      });
    } else {
      navigate(url);
    }
    setMobileOpen(false);
  };

  useEffect(() => {
    dispatch(loginActions.redirectUrlRequest(location?.pathname));
  }, [location?.pathname, dispatch]);

  if (isPageNotFound === true) {
    return (
      <div className="container_wrapper">
        <Outlet />
      </div>
    );
  }

  return (
    <>
      {isAuth && token && !isPageNotFound ? (
        <>
          {islanding ? (
            <>
              <Navbar
                handleDrawerToggle={handleDrawerToggle}
                islanding={true}
              />
              <div className="container_wrapper">
                <Outlet />
              </div>
            </>
          ) : (
            <div className="dashboard">
              <div className="contentContainer">
                <Drawer
                  container={container}
                  variant="temporary"
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  ModalProps={{
                    keepMounted: true,
                  }}
                  sx={{
                    display: { xs: "block", sm: "block" },
                    "& .MuiDrawer-paper": {
                      boxSizing: "border-box",
                      width: drawerWidth,
                    },
                  }}
                >
                  <Sidebar handleRoute={handleRoute} location={location} />
                </Drawer>

                <Drawer
                  variant="permanent"
                  className="drawerContainer"
                  sx={{
                    "& .MuiDrawer-paper": {
                      boxSizing: "border-box",
                      width: drawerWidth,
                    },
                  }}
                  open
                >
                  <Sidebar handleRoute={handleRoute} location={location} />
                </Drawer>

                <div className="rightBar">
                  <Navbar handleDrawerToggle={handleDrawerToggle} />
                  <div className="container_wrapper">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <Navigate to="/login" replace={true} />
      )}
    </>
  );
};

export default PrivateRoutes;
